import ElongRoomSourceOrderList from '@/pages/elong/roomSourceOrderList';
import ElongOrderDetail from '@/pages/elong/orderDetail';
import ElongTransaction from '@/pages/elong/transactionRecord';
import ElongReport from '@/pages/elong/promotionReport';


// 房间来源订单列表
export const elongRoomSourceOrderList = {
  path: 'elong/roomSourceOrderList',
  component: ElongRoomSourceOrderList
}
// 订单详情
export const elongOrderDetail = {
  // path: 'Elong/Elong/elongOrderDetail',
  path: 'elong/orderDetail',
  component: ElongOrderDetail
}
// 交易记录
export const elongTransactionRecord = {
  path: 'elong/transactionRecord',
  component: ElongTransaction
}
// 艺龙推广报表
export const elongPromotionReport = {
  path: 'elong/promotionReport',
  component: ElongReport
}



// WEBPACK FOOTER //
// ./src/router/elong.js